import { render, staticRenderFns } from "./PanelRowsWide.vue?vue&type=template&id=f795ffbc&scoped=true&"
import script from "./PanelRowsWide.vue?vue&type=script&lang=js&"
export * from "./PanelRowsWide.vue?vue&type=script&lang=js&"
import style0 from "./PanelRowsWide.vue?vue&type=style&index=0&id=f795ffbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f795ffbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
